<template>
    <CContainer fluid class="position-relative">
        <CElementCover :opacity="1" class="gjs-mdl-container-overlay" v-if="!sm_steps.isActive()">
            <div class="text-center">
                <CIcon
                    class="icon"
                    :content="$options.icons.cilWarning"
                    size="xl"
                />
                <h2>Storage step is disable!</h2> 
                <hr class="my-4">
                <p v-if="isTemplateStep()">If you want to work with step you have to activate the storage step.</p>
                <p v-else>Transform template to step</p>
                <CSwitch
                    @update:checked="toggleStorageStep()"
                    shape="pill"
                    color="primary"
                />
            </div>
        </CElementCover>
        <CRow alignHorizontal="end">
            <CCol :sm="2">
                <CDropdown
                    class="modal_editor__dropdown"
                    color="primary"
                    toggler-text="" 
                    :style="{
                        float:'right',
                    }"
                    size="sm"
                >
                    <CDropdownItem @click="toggleStorageStep()">{{(sm_steps.isActive()) ? "Disable":"Active" }}</CDropdownItem>
                    <CDropdownDivider></CDropdownDivider>
                    <CDropdownItem @click="createStepBlank()">Step blank</CDropdownItem>
                    <CDropdownItem @click="cloneTemplate()">Clone template</CDropdownItem>
                    <CDropdownItem @click="deleteAllSteps()" disabled>Delete all steps </CDropdownItem>
                </CDropdown>
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <CDataTable
                    :items="tables.steps.items"
                    :fields="tables.steps.fields"
                    v-bind="tables.steps"
                    :items-per-page="tables.steps.rows"
                    pagination
                    :addTableClasses="['text-white']"
                >
                    <template #thead-top>
                        
                    </template>
                    <template #id="{ item }">
                        <td>
                            Step {{ item.order_step }}
                        </td>
                    </template>
                    <template #active="{ item }">
                        <td>
                            <CBadge :color="getBadgeActive(item.active)">
                                {{(item.active)? 'Active':'Disable'}}
                            </CBadge>
                        </td>
                    </template>
                    <template #options="{ item }">
                        <td>
                            <CButton
                                color="primary"
                                class="mx-1"
                                variant="outline"
                                square
                                size="sm"
                                @click="
                                    $router.push({
                                        name: 'step_builder',
                                        params:{
                                            stepId:item.uuid,
                                            templateId:opts.template_id
                                        }

                                    })
                                "
                            >
                                <CIcon
                                    class="icon"
                                    :content="$options.icons.cilSettings"
                                />
                            </CButton>
                            <CButton
                                color="success"
                                class="mx-1"
                                variant="outline"
                                square
                                size="sm"
                                @click="cloneStep(item)"
                            >
                                <CIcon
                                    class="icon"
                                    :content="$options.icons.cilCopy"
                                />
                            </CButton>
                            <CButton
                                color="danger"
                                class="mx-1"
                                variant="outline"
                                square
                                size="sm"
                                @click="deleteStep(item)"
                            >
                                <CIcon
                                class="icon"
                                :content="$options.icons.cilTrash"
                                />
                            </CButton>
                        </td>
                    </template>
                    <template #move='{ item }'>
                        <td>
                            <CButtonGroup v-if="item.order_step != 0">
                                <CButton 
                                    color="light"
                                    variant="outline"
                                    square
                                    size="sm"
                                    :disabled="item.order_step == 1" 
                                    @click="moveStepUp(item.order_step)"
                                >
                                    <CIcon
                                        class="icon"
                                        :content="$options.icons.cilArrowTop"
                                    />
                                </CButton>
                                <CButton
                                    color="light"
                                    variant="outline"
                                    square 
                                    size="sm"
                                    :disabled="item.order_step == tables.steps.items.length - 1"
                                    @click="moveStepDown(item.order_step)"
                                >
                                    <CIcon
                                        class="icon"
                                        :content="$options.icons.cilArrowBottom"
                                    />
                                </CButton>
                            </CButtonGroup>
                        </td>
                    </template>
                </CDataTable>
            </CCol>
        </CRow>
        <CRow alignHorizontal="end">
            <CCol sm="9">
                <!-- Buttons control -->
                <CButtonGroup>
                    <CButton @click="createStepBlank()" color="light">
                        Step blank
                    </CButton>
                    <CButton @click="cloneTemplate()" color="light">
                        Clone template
                    </CButton>
                </CButtonGroup>
                
            </CCol>
            <CCol sm="3">
                <CButton 
                    :style="{
                        float:'right',
                    }" 
                    color="light"
                    @click="closeModal()"
                >
                    Close
                </CButton>

            </CCol>
        </CRow>
        
    </CContainer>
</template>

<script>

import { cilPlus, cilSettings, cilStorage, cilCopy, cilTrash, cilArrowBottom, cilArrowTop, cilWarning } from "@coreui/icons";
export default {
    name:"ModalStepEditor",
    icons: {
        cilPlus,
        cilSettings,
        cilStorage,
        cilCopy,
        cilTrash,
        cilArrowBottom, 
        cilArrowTop,
        cilWarning
    },
    data: function () {
        return {
            tables:{
                steps:{
                    fields: [
                        {
                            key: "order_step",
                            label: "#",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "id",
                            label: "Name",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "active",
                            label: "Active",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key:'options',
                            label:"Options",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key:'move',
                            label:"",
                            sorter: false,
                            filter: false,
                        }
                    ],
                    items: [],
                    order: "asc",
                    page: 1,
                    rows: 5,
                    total_pages: 1,
                    loading: true,
                    hover:true,
                    pagination:true,
                    sorter:true,
                    dark:false
                }
            },
            transProps: {
                // Transition name
                name: 'flip-list'
            },
            // sm_steps:null,
            storage_step_active:true,
            is_template_step:false,
            template: null

        }
    },
    props:{
        editor:{},
        opts:{}
    },
    computed:{
        pageWithStepActive(){
            let rows = this.tables.steps.rows;
            let items =  this.tables.steps.items;
            let total_items = items.length;
            let total_pages = Math.ceil(total_items/rows);
            for (let i = 0; i < total_items; i++) {
                const item = items[i];
                if(item.active){
                    for (let j = 1; j <= total_pages; j++) {
                        if(i+1<=j*rows){
                            return j;
                        }
                        
                    }
                }
            }
            return 1;
        },
    },
    computed:{
        sm_steps:function() {
            let sm = this.editor.StorageManager;
            return sm.get(this.opts.storage_name);
        }
    },
    methods:{
        getBadgeActive (active) {
            if(active)  return 'success';
            else return 'secondary';
        },
        itemPerPage(newValue){
            this.tables.steps.rows = newValue;
            this.updatePagination(this.tables.steps.page);
        },
        updatePagination(newValue) {
            this.tables.steps.page = newValue;
        },
        async loadData(){

            this.sm_steps.loadTemplate(this.opts.template_id).then((result)=>{
                this.sm_steps.loadListSteps(result.uuid).then((result)=>{
                    this.tables.steps.items = result.map((item)=>{
                        return{
                            ...item,
                            active:(this.sm_steps.current_step == item.uuid) ? true:false
                        }
                    });
                    this.tables.steps.page = this.pageWithStepActive;
                    if(this.tables.steps.items.length > 0){
                        this.tables.steps.loading = false;
                    }
                });
            })
        },
        createStepBlank:function(){
            this.sm_steps.createStepBlank();
            this.closeModal();
        },
        cloneTemplate:function(){      
            this.sm_steps.cloneTemplate();
            this.closeModal();
        },
        deleteAllSteps:function(){
            this.sm_steps.deleteAllSteps();
            this.closeModal();
        },
        deleteStep:function(step){
            this.sm_steps.deleteStep(step);
            this.closeModal();
        },
        cloneStep(step){
            this.sm_steps.cloneStep(step);
        },
        isTemplateStep(){
            if( this.sm_steps.template_info && this.sm_steps.template_info.is_template_step){
                return true;
            }else{
                return false;
            }
        },
        activeStorageStep(){
            let sm = this.editor.StorageManager;
            sm.setCurrent(this.opts.storage_name);
            this.sm_steps.activeStorageStep();
            this.loadData();
        },
        async disableStorageStep(){
            await this.sm_steps.disableStorageStep();
        },
        async toggleStorageStep(){
            let is_active = this.sm_steps.isActive();
            if(is_active){
                this.disableStorageStep();
            }else{
                this.activeStorageStep();
                await this.loadData();
            }
        },
        async updateStorateStep(){
            let sm = this.editor.StorageManager;
            this.sm_steps = sm.get(this.opts.storage_name);
            await this.sm_steps.initStorage();
            await this.sm_steps.loadTemplate();
        },
        moveStepUp(index){

            let list_steps = [
                ...this.tables.steps.items
            ]; 

            let step = this.tables.steps.items[index];
            step.order_step = index - 1;
            this.sm_steps.updateStep(step);

            let temp = list_steps[index - 1];
            temp.order_step = index;
            this.sm_steps.updateStep(temp);

            list_steps[index - 1] = step;
            list_steps[index] = temp;

            this.tables.steps.items = list_steps;
        },
        moveStepDown(index){

            index = parseInt(index);
            let list_steps = [
                ...this.tables.steps.items
            ]; 

            let step = this.tables.steps.items[index];
            step.order_step = index + 1;
            this.sm_steps.updateStep(step);

            let temp = list_steps[index + 1];
            temp.order_step = index;
            this.sm_steps.updateStep(temp);

            list_steps[index + 1] = step;
            list_steps[index] = temp;

            this.tables.steps.items = list_steps;
        },
        getStepsList(){
            return this.tables.steps.items;
        },
        closeModal(){
            this.editor.Modal.close();
        },
        saveChanges(){
            this.closeModal();
        }
    },
    async mounted(){
        this.template = this.sm_steps.template_info;
    },
    async created(){
        this.storage_step_active = this.sm_steps.isActive();
        if(this.storage_step_active){
            await this.loadData();
        }
        this.tables.steps.loading = false;
    }
}
</script>

<style lang="scss">
    .modal_editor__dropdown{
        & .dropdown-toggle{
            background: transparent !important;
        }
    }

    .gjs-mdl-container-overlay{
        background-color: #463a3c !important;
        z-index: 1600;
    }

</style>